import { render, staticRenderFns } from "./SetDeadline.vue?vue&type=template&id=6c972f53"
import script from "./SetDeadline.vue?vue&type=script&lang=js"
export * from "./SetDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports